import { SubprogramService } from '@modules/subprogram/subprogram-service';
// import { SubprogramRegularSeasonRoundsModel } from  '@modules/subprogram/subprogram-regular-season-rounds-model';
import RelationToOneField from '@shared/fields/relation-to-one-field';
import RelationToManyField from '@shared/fields/relation-to-many-field';
import Permissions from '@security/permissions';

export class SubprogramRegularSeasonRoundsField {
  static relationToOne(name, label, options) {
    return new RelationToOneField(
      name,
      label,
      '/subprogram',
      Permissions.values.subprogramRead,
      SubprogramService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }

  static relationToMany(name, label, options) {
    return new RelationToManyField(
      name,
      label,
      '/subprogram',
      Permissions.values.subprogramRead,
      SubprogramService.listAutocomplete,
      (record) => {
        if (!record) {
          return null;
        }

        return {
          id: record.id,
          label: record.name,
        };
      },
      options,
    );
  }
}


// import GenericField from '@shared/fields/generic-field';
// import { SubprogramRegularSeasonRoundsModel } from  '@modules/subprogram/subprogram-regular-season-rounds-model';

// export default class SubprogramRegularSeasonRoundsField extends GenericField {
//   constructor(name, label) {
//     super();
//     this.name = name;
//     this.label = label;
//     this.initialValue = Object.keys(SubprogramRegularSeasonRoundsModel.fields).reduce((result, field) => {
//       result[field] = undefined;
//       return result;
//     }, {});
//   }

//   forPresenter(value) {
//     return value || this.initialValue;
//   }

//   forFilterInitialValue(value) {
//     return value || this.initialValue;
//   }

//   forFormInitialValue(value) {
//     return value || this.initialValue;
//   }

//   forFilterCast() { }

//   forFilterRules() { }

//   forFormCast() { }

//   forFormRules() { }
// }